<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="contactPhoneForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                contactPhoneForm: () => import('../forms/ContactPhoneForm'),
                headers: [
                    { text: 'Contact', value: 'contactId', table: 'contacts', form: () => import('../forms/ContactForm') },
                    { text: 'Phone Number', value: 'phoneNumber' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    contacts: [],
                    items: []
                },
                sorting: [
                    { column: "phoneNumber", direction: "ascending" },
                    { column: "contactId", direction: "ascending" },
                ],
                itemsField: 'contactPhones',
                editPageName: 'contactPhone',
                apiMethod: 'ContactPhones',
                claimName: 'ContactPhones',
                formTitle: 'Contact Phone',
                excelTitle: 'Contact Phones',
                hasEditPage: false,
            }
        },
    };
</script>
